
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

/**
 * Componente de ruta protegida robusto.
 * @param {Array} allowedRoles - Lista de roles permitidos ['Administrador', etc]
 * @param {Boolean} checkSuperAdmin - Si es true, exige ser Super Admin (ignora allowedRoles)
 */
const ProtectedRoute = ({ children, allowedRoles = [], checkSuperAdmin = false }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
     // Spider-man loading state o simple spinner
     return <div className="flex h-screen items-center justify-center">Cargando...</div>;
  }

  // 1. Verificar autenticación básica
  if (!isAuthenticated) {
     return <Navigate to="/" state={{ from: location }} replace />;
  }

  // 2. Verificar Super Admin si se requiere
  if (checkSuperAdmin) {
      if (user?.isSuperAdmin) {
          return children;
      } else {
          // Si está logueado pero no es Super Admin, mandar a Panel normal o 403
          return <Navigate to="/panel" replace />;
      }
  }

  // 3. Verificar Roles Específicos (Si no es checkSuperAdmin explícito)
  // Nota: Super Admin siempre tiene acceso a todo, idealmente.
  if (user?.isSuperAdmin) {
      return children;
  }

  // Si se definieron roles permitidos y el usuario no tiene ninguno
  if (allowedRoles.length > 0) {
     const hasPermission = allowedRoles.some(role => user?.roles?.includes(role));
     // Fallback legacy: a veces 'user.rol' es un string, no array
     const legacyRoleMatch = allowedRoles.includes(user?.rol); 
     
     if (!hasPermission && !legacyRoleMatch) {
         return <div className="p-8 text-center text-red-600 font-bold">No tienes permisos para acceder a esta ruta.</div>;
     }
  }

  return children;
};

export default ProtectedRoute;
